"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleMouseUp = exports.getSortedJsonWrtDates = exports.FormatChanger = void 0;
const getSortedJsonWrtDates = jsonArray => {
  try {
    let arrayWithSlashDateString = jsonArray.map(ele => {
      let Dates = ele.date.split("-").join("/");
      return {
        ...ele,
        newDate: Dates
      };
    });
    let arrayWithDatesDesc = arrayWithSlashDateString.sort((a, b) => {
      return Date.parse(b.newDate) - Date.parse(a.newDate);
    });
    return arrayWithDatesDesc;
  } catch (e) {
    console.log("Error in getSortedJsonWrtDates: ", e);
    return [];
  }
};
exports.getSortedJsonWrtDates = getSortedJsonWrtDates;
const FormatChanger = date => {
  let modifiedDate = date.split("-").join("/");
  let d = new Date(modifiedDate);
  let convertedDate = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
  return convertedDate;
};

/** Function to differentiate between a normal click and a drag */
exports.FormatChanger = FormatChanger;
const handleMouseUp = function (e) {
  let clickPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let callBack = arguments.length > 2 ? arguments[2] : undefined;
  if (e.clientX - clickPosition === 0) {
    callBack();
  }
};
exports.handleMouseUp = handleMouseUp;